<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add M-code</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.mcode" label="mcode" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="form.name" label="Name" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field v-model="form.price_other" label="Forfait" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field v-model="form.price_dialyse" label="Forfait dialyse" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field v-model="form.price_radio" label="Forfait radio" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field v-model="form.price_chemo" label="Forfait chemo" required :rules="itemRules"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import FormMixin from '@/mixins/formvalid';
  export default {
    mixins: [FormMixin],
    props: ['dialog', 'mdata', 'form'],
    data () {
      return {
        valid: false
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.$emit('save', this.form);
        }
      },
      close () {
        this.$emit('close');
      },
      prefill (d) {
        for (var key in d) {
          this.form[key] = d[key]; // copies each property to the form object
        }
      },
      init (v) {
        if (v) {
          this.prefill(this.mdata);
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>

